export enum ChatMessageStatusType {
  MODERATE = 'moderate',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}
